import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router';
// import LoginForm from '../components/login/LoginForm';
import { Navigate } from 'react-router';
import BasicLayout from '../layouts/BasicLayout';

function Profile() {
  const [ebayAccessToken, setEbayAccessToken] = useState('');

  // get code from url
  useEffect(() => {
    async function getAndSetCode() {
      console.log('get eBay access token from cookie');
      
      // if we have a code in the url, we are logging in with our code from ebay
      if (window.location.search.includes('code')) {
        // setCode(new URLSearchParams(window.location.search).get('code'));
        const newCode = new URLSearchParams(window.location.search).get('code');
        console.log("abc3 new code: ", newCode);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/ebay/callback?code=${encodeURIComponent(newCode)}`)
        const data = await response.json();
        console.log("abc3 data: ", data);
        console.log("USER DATA FROM EBAY");
        document.cookie = `ebayAccessToken=${data?.ebayAccessToken?.access_token}; path=/; expires=${new Date(Date.now() + (1000 * data?.ebayAccessToken?.expires_in)).toUTCString()}`;
        console.log("abc3 ebay access token: ", data?.ebayAccessToken?.access_token);
        console.log("cookie set");
        setEbayAccessToken(data?.ebayAccessToken?.access_token);
      }
      else {
        console.log("no code in url");
        setEbayAccessToken('undefined');
      }
    }
    getAndSetCode();
  }, []);

  return (
    <>
      {!ebayAccessToken && <BasicLayout><p>Loading...</p></BasicLayout>}
      {ebayAccessToken && ebayAccessToken === 'undefined' && <Navigate to="/" replace />}
      {ebayAccessToken && ebayAccessToken !== 'undefined' && <Navigate to="/account" replace />}
    </>
  );
}

export default Profile;
